import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UpsellComponent} from './upsell/upsell.component';
import {MatLegacySnackBarModule as MatSnackBarModule} from '@angular/material/legacy-snack-bar';
import {TranslateModule} from '@ngx-translate/core';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';


@NgModule({
    declarations: [
        UpsellComponent
    ],
    imports: [
        CommonModule,
        MatSnackBarModule,
        TranslateModule,
        MatButtonModule
    ]
})
export class OnboardingModule {
}
